import React from 'react';
import io from 'socket.io-client'; 
import Config from '../config'

async function fetchJson(hashtag){
  const res = await fetch(hashtag)
  return await res.json()
}

async function fetchTwitterSearchResults(hashtag){
  return await fetchJson(`${Config.PROXY}/twitter?hashtag=${encodeURIComponent(hashtag)}`)
}

export default function connectTweets(Component){
    return class ConnectedTweets extends React.Component {
      state = {
        tweets: null
      }
  
      async componentDidMount(){
      
        const { hashtag } = this.props
        
        this._isMounted = true
        
  
        const newTweets = await fetchTwitterSearchResults(hashtag)
        newTweets.sort((d1, d2) => new Date(d2.date).getTime() - new Date(d1.date).getTime())
        this.setState({tweets: newTweets}); 


        const maxCount = 10
        const socket = io('http://localhost:3011', {
          query: "type=twitter&hashtag=" + hashtag    
        })
        this.socket = socket
        socket.on('connect', () => {
          socket.on("tweet", data => { 
            this._isMounted = false
  
            if (newTweets.length===maxCount) 
            {
              newTweets.pop(); 
            }
            newTweets.push(data); 
            newTweets.sort((d1, d2) => new Date(d2.date).getTime() - new Date(d1.date).getTime()); //sort tweets array
            this.setState({tweets: newTweets}); 
          })
        })
      }
  
      componentWillUnmount(){
        this._isMounted = false
  
        if (this.socket){
          this.socket.disconnect()
          this.socket = null
        }
      }
  
      render(){
        if (!this.state.tweets) return null
        return <Component {...this.props} {...this.state} />
      }
    }
  
  }


// WEBPACK FOOTER //
// ./src/connectors/tweetsConnector.js